import React from "react";
import moment from "moment";
import PLANE from "../../assets/images/plane.png";
import {
  getArrivalDayMessage,
  getTotalTravelDuration,
} from "../../_helpers/dateUtils";
import { FlightImage } from "../../components/flightimage/FlightImage";

interface FlightRouteProps {
  route: any;
  startTime: moment.Moment;
  endTime: moment.Moment;
  remainingSeats: number;
  openFightDetail: boolean;
  setOpenFlightDetail: (openflightDetail: boolean) => void;
}

const FlightRoute = ({
  route,
  startTime,
  endTime,
  setOpenFlightDetail,
  openFightDetail,
  remainingSeats,
}: FlightRouteProps) => {
  const flightNamesArray =
    route?.Segments?.map((segment: any) => segment?.Airline_Name) || [];
  const uniqueFlightNames = Array.from(new Set(flightNamesArray));
  const flightCodesArray =
    route?.Segments?.map((segment: any) => segment?.Airline_Code) || [];
  const uniqueFlightCodes = Array.from(new Set(flightCodesArray));
  const flightDetails =
    route?.Segments?.reduce(
      (acc: string[], segment: any, index: number, array: any[]) => {
        const flightNo = segment?.Flight_Number;
        const flightCode = segment?.Airline_Code;

        // Add flight details if not already added
        if (!acc.some((detail) => detail.includes(flightNo))) {
          acc.push(`${flightCode} - ${flightNo}`);
        }

        // Always add the last item
        if (
          index === array.length - 1 &&
          !acc[acc.length - 1].includes(flightNo)
        ) {
          acc.push(`${flightCode} - ${flightNo}`);
        }

        return acc;
      },
      []
    ) || [];

  return (
    <div className="flight-mobile">
      <div className="flight-flex">
        <div className="fight-name">
          {uniqueFlightCodes?.length > 1 ? (
            <div style={{ height: 40, width: 40, display: "flex" }}>
              {uniqueFlightCodes?.map((code: any, index: number) => {
                if (index < 2) {
                  return (
                    <FlightImage
                      key={code}
                      flightCode={code}
                      style={{
                        height: 20,
                        width: 20,
                        marginBottom: index === 0 ? 20 : 0,
                        marginTop: index === 0 ? 0 : 20,
                      }}
                    />
                  );
                }
              })}
            </div>
          ) : (
            uniqueFlightCodes?.map((code: any) => {
              return <FlightImage key={code} flightCode={code} />;
            })
          )}
          <span>
            <h5>{uniqueFlightNames.join(", ")}</h5>
            <p>{flightDetails.join(", ")}</p>
          </span>
        </div>
        <div className="route-timing">
          <div className="route-strating">
            <p>{route?.Segments[0]?.Origin_City}</p>
            {moment(startTime)?.format("HH:mm")}
            <p>{moment(startTime)?.format("MMM DD")}</p>
          </div>
          <div className="cunsume-time">
            <span>
              {route?.Segments?.length - 1 === 0
                ? "Non-Stop"
                : `${route?.Segments?.length - 1} Stop`}
            </span>
            <div className="cunsume-pic">
              <img src={PLANE} alt="" />
            </div>
            {/* <p>{getDiffInHRAndMin(startTime, endTime)}</p> */}
            <p>{getTotalTravelDuration(route?.Segments)}</p>
          </div>
          <div className="route-strating">
            <p>
              {route?.Segments[route?.Segments?.length - 1]?.Destination_City}
            </p>
            {moment(endTime)?.format("HH:mm")}
            <p>{moment(endTime)?.format("MMM DD")}</p>
          </div>
        </div>
      </div>
      {/* need to change here onclick and make the content dynamic*/}
      <a
        data-rid="3"
        className="view-detail"
        onClick={() => {
          setOpenFlightDetail(!openFightDetail);
        }}
      >
        {"View Detail"}
        <span className="plus-button">{openFightDetail ? "-" : "+"}</span>
      </a>
      <div className="flight-left">
        <span>
          {getArrivalDayMessage(startTime, endTime) && (
            <img src={PLANE} alt="" />
          )}
          {getArrivalDayMessage(startTime, endTime)}
          {remainingSeats && (
            <span
              className={`${
                remainingSeats <= 5
                  ? "text-danger"
                  : remainingSeats > 5 && remainingSeats <= 10
                  ? "text-warning"
                  : ""
              }`}
            >
              {`Seats left : ${remainingSeats}`}
            </span>
          )}
        </span>
      </div>
    </div>
  );
};

export default FlightRoute;
